import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import InnerLoader from "../Loader/InnerLoader";
import { OverlayLoader } from "../Loader/OverlayLoader";
import Loader from "../Loader/loader";
/* refactored - ali */
const RemoveDialog = ({ toggleDeleteDialog, onDelete, message, message2, message3, Title, deleteButtonText, cancelButtonText, hideCancelButton, hideDeleteButton, showLoader, process, referenceAttr, focusAttribute, orgName, projectName, currentEntity, referenceMessage, loading }) => {
	function remove(e) {
		e.target.disabled = true;
		onDelete(e);
	}

	return (
		<Dialog width={"30%"} title={Title} onClose={toggleDeleteDialog}>
			{showLoader && <OverlayLoader />}
			{loading ?
				<div className="deleteLoader"><Loader /></div> :
				<>
					<div className="d-flex my-3 align-items-center dialog-content">
						<i className="fas fa-exclamation-triangle text-danger display-7 me-4"></i>
						<div>
							{message}
							{message2 &&
								<div className="mt-1">
									{message2}
								</div>
							}
							{message3 &&
								<div className="mt-1">
									{message3}
								</div>
							}
						</div>
					</div>
					<DialogActionsBar layout="end">
						<div className="m-2">
							{showLoader && (
								<>
									<small className="mt-2">
										<div className="d-inline-block">
											<InnerLoader borderColor="red" />
											<span className="me-4 text-danger"></span>
										</div>
									</small>
									{process && process.message && process.message.length > 0 && (
										<small>
											{process.message}
										</small>)
									}
								</>
							)}
							<button autoFocus={true} className="btn btn-secondary" onClick={toggleDeleteDialog}>
								{cancelButtonText || "Cancel"}
							</button>
							<button className="btn btn-danger" onClick={remove}>
								{deleteButtonText}
							</button>
						</div>
					</DialogActionsBar>
				</>
			}
		</Dialog>
	);
};

export default RemoveDialog;
